/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface PinStaffListRequest
 */
export interface PinStaffListRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof PinStaffListRequest
   */
  userIds?: Array<string>
}

export function PinStaffListRequestFromJSON(json: any): PinStaffListRequest {
  return PinStaffListRequestFromJSONTyped(json, false)
}

export function PinStaffListRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PinStaffListRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    userIds: !exists(json, 'user_ids') ? undefined : json['user_ids']
  }
}

export function PinStaffListRequestToJSON(value?: PinStaffListRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    user_ids: value.userIds
  }
}
